<!-- 历史交易和需求 -->
<template>
  <div>
    <a-list :dataSource="historyList" :pagination="listPagination">
      <a-list-item slot="renderItem" slot-scope="item,index">
        <a-list-item-meta>

          <!-- 主体图标 -->
          <div slot="avatar">
            <div class="avatar" >
              <pt-icon v-if="item.flag == '1'" type="icon-zhuizong-hei" class="edit_icon_one"></pt-icon>
              <pt-icon v-else type="icon-jiaoyi-hei" class="edit_icon_one"></pt-icon>
            </div>
          </div>

          <div slot="title">
            <!-- 标题 -->
            <div class="reminderTitle">
              <a-row class="followerHeader">
                <a-col :span="4">
                  <div class="titleStyle">
                    {{ item.flag == '1' ? $t('track.trackDetail.pursuits') : $t('track.trackDetail.deal') }}
                  </div>
                </a-col>
                 <a-col :span="20">
                     <div @click="showDetailRecord(item)" v-show="showDetailButtons">
                       <pt-icon type="icon-xiangqingcopy" class="edit_icon"></pt-icon>
                     </div>
                </a-col>
              </a-row>
            </div>

          <div>
            <a-row>
              <!-- 团队 -->
              <a-col :span="6">
                <div class="contentStyle">
                  {{$t('track.tableLabel.team')}}：
                </div>
              </a-col>

              <a-col :span="18">
                <avatar-list v-if="item.flag == '1'" size="small" :max-length="4" :list-length="item.pursuitsAccountVO.length">
                  <avatar-list-item :tips="account.employeeDO.userName" v-for="account in item.pursuitsAccountVO" :key="account.accountDO.id"
                                    :src="getHeadImg(account.employeeDO.headimg)" />
                </avatar-list>
                <avatar-list v-else size="small" :max-length="3" :list-length="item.dealAccountVO.length">
                  <avatar-list-item :tips="account.employeeDO.userName" v-for="account in item.dealAccountVO" :key="account.accountDO.id"
                                    :src="getHeadImg(account.employeeDO.headimg)" />
                </avatar-list>
              </a-col>
            </a-row>
          </div>

            <div style="margin-top: 10px">
              <a-row>
                <!-- 状态 或者 追踪状态 -->
                <a-col :span="6">
                  <div class="contentStyle">
                    {{ item.flag == '1' ? $t('track.tableLabel.demandStatus') : $t('track.tableLabel.stage') }}:
                  </div>
                </a-col>
                <a-col :span="18" style="font-size: 12px;color: #333333;font-weight: 600;">
                  <span v-if="item.flag == '1'">
                    {{ item.status ==0 ? '~' : $t('track.demandStatus.'+(item.status-1)).name}}
                  </span>
                  <span  v-if="item.flag =='2' && item.dealOriginType == 1">
                    {{$t('deal.dealDetails.leaseProjectStageTypes.'+item.status)}}
                  </span>
                  <span  v-if="item.flag =='2' && item.dealOriginType == 2">
                    {{$t('deal.dealDetails.consultantProjectStageTypes.'+item.status)}}
                  </span>
                </a-col>
              </a-row>
            </div>

            <!-- 创建时间 -->
            <div style="margin-top: 10px">
              <a-row>
                <a-col :span="6">
                  <div class="contentStyle">
                    {{$t('track.queryParams.createTimeRange')}}:
                  </div>
                </a-col>
                <a-col :span="18"  style="font-size: 12px;color: #333333;font-weight: 600;">
                  {{item.createTime}}
                </a-col>
              </a-row>
            </div>

            <!-- 最新跟进时间 -->
            <div style="margin-top: 10px">
              <a-row>
                <a-col :span="6">
                  <div class="contentStyle">
                    {{$t('track.tableLabel.newLast')}}:
                  </div>
                </a-col>
                <a-col :span="18"  style="font-size: 12px;color: #333333;font-weight: 600;">
                  {{item.createTime}}
                </a-col>
              </a-row>
            </div>


          </div>





        </a-list-item-meta>
      </a-list-item>
    </a-list>



    <!-- 交易 -->
    <pt-modal  :title="$t('customer.customerDetail.dealTitle')"
               :visible="visibleDeal" :width="1230"  :footer="true" @cancel="visibleDeal=false">
      <div slot="content">
        <deal-detail  :dealId="businessId" :showFunctionButton="false" :showEditButton="false"></deal-detail>
      </div>
    </pt-modal>

    <!-- 需求 -->
    <pt-modal  :title="$t('customer.customerDetail.pursuitsTitle1')"
               :visible="visiblePursuits" :width="1230"  :footer="true" @cancel="visiblePursuits=false">
      <div slot="content">
        <track-detail  :pursuitsId="businessId"  :hideEdit="true"></track-detail>
      </div>
    </pt-modal>

  </div>

</template>

<script>
import { userMixin } from '@/utils/mixin'
import pursuitsApi from '@/api/mine/pursuit'
import AvatarList from '../../../../components/AvatarList/List'
import AvatarListItem from '../../../../components/AvatarList/Item'

export default {
  name: 'historyDealAndDemand',
  components: {  AvatarList,AvatarListItem,
                  dealDetail : ()=>import('../../deal/dealDetails'),
                  trackDetail : ()=>import('../module/trackDetail')
  },
  data() {
    return {
      visiblePursuits:false,
      visibleDeal:false,
      businessId:null,
      showDetailButtons:true,
      historyList: []
    }
  },
  mixins:[userMixin],
  props: {
    customerId: {
      type: String,
      default: null
    },
    pursuitsId:{
      type: String,
      default: null
    },
    listPagination:{
      type: Object,
      default:()=>{
        return null
      }
    },

  },
  mounted() {
    this.initData()
      console.log("登录人信息",this.userInfo.accountDO.id)
  },

  methods: {

    initData() {
      pursuitsApi.selectHsitoryDelAndNee(this.customerId,this.pursuitsId).then(res => {
        console.log('res', res)
        if (res.code == 1) {
          this.historyList = res.data.records
        }
      })
    },

    getHeadImg(headimg){
      return this.$util.getFileUrl(headimg)
    },
    getImageUrl(userId){
      return this.$util.getHeadImgUrl(userId)
    },

    showDetailRecord(item){
      if(item.permissions){
        let flag = item.flag;
        this.businessId = item.id;
        if(flag == '1'){
          this.visiblePursuits = true
        }else{
          this.visibleDeal = true
        }
      }else{
        this.$message.error("您没有查看详情的权限！")
      }
    },


  }

}
</script>

<style scoped lang="less">

.avatar{
  width: 40px;
  height: 40px;
  background-color: #EBEBEB;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center
}

.followerHeader{
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #999999;


  .titleStyle{
    font-size: 14px;
    color: #4D4D4D;
    font-weight: 600;
  }
}
.edit_icon_one{
  font-size: 18px;
  float:right;
  cursor:default !important
}
.edit_icon{
  font-size: 18px;
  float:right;
}
.reminderTitle{
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #999999;
  margin-bottom: 10px;
}

.contentStyle{
  font-size: 12px;
  color: #999999;
  letter-spacing: 0;
  font-weight: 600;
}

</style>